module.exports = __webpack_public_path__ + "media/fonts/BrandonGrotesque-Medium-0941c8aafcfd8412b03330860404634c.svg";